import httpClient from '@/http-client'

export const get = (options = {}) => {
  return httpClient
    .get('/api/org-chart-levels', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/org-chart-levels', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, options = {}) => {
  return httpClient
    .get(`/api/org-chart-levels/${id}`, options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/org-chart-levels/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient.delete(`/api/org-chart-levels/${id}`).then(response => Promise.resolve(response.data))
}

export default { get, store, find, update, destroy }
